import styled from 'styled-components';
import themeGet from '@styled-system/theme-get';

export const Section = styled.div`
  width: 432px;
  background-color: ${themeGet('colors.white')};
  border: 1px solid ${themeGet('colors.black.10')};
  border-radius: 8px;
`;

export const SectionBody = styled.div`
  border-top: 1px solid ${themeGet('colors.black.10')};
  padding: 20px;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const ToggleContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 10px;
  margin-bottom: 24px;
`;

export const ToggleLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  opacity: ${props => (props.isReminderTab ? '0.4' : '1')};
`;
